export const API = {
    data: 'https://api.openweathermap.org/data/2.5/weather',
    key: '4e8cf411e5d3eec5f03c7af9ee067417'
}